import { useQuery } from "@tanstack/react-query";

import { apiFetch, buildParams } from "@/lib/api";
import type { RecentAviItem } from "@/types";

type Params = {
  account_id: string;
  role: string;
};

export function useRecentAvi(params: Params, enabled = true) {
  const query = buildParams(params);

  return useQuery({
    queryKey: ["recent-avis", params],
    queryFn: () => apiFetch<RecentAviItem[]>(`/v1/home/recent-avis${query}`),
    enabled,
    refetchOnMount: "always",
  });
}
